import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {UserVisioState} from "../../../core/models/user-visio-state.model";

@Component({
  selector: 'app-user-visio-state',
  templateUrl: './user-visio-state.component.html',
  styleUrls: ['./user-visio-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserVisioStateComponent {

  private _userState!: UserVisioState;
  private _userType: 'remote' | 'connected' = 'remote';

  get userState(): UserVisioState {
    return this._userState;
  }

  @Input({required: true})
  set userState(value: UserVisioState) {
    this._userState = value;
  }

  get userType(): "remote" | "connected" {
    return this._userType;
  }

  @Input({required: true})
  set userType(value: "remote" | "connected") {
    this._userType = value;
  }

  protected readonly window = window;
}
